import PropTypes from 'prop-types';
import React from 'react';

import Image from 'components/ImageV2';
import { IMAGE_RATIOS, IMAGE_WIDTHS, IMAGE_BG_COLOR } from 'constants/images';
import { mediumUp } from 'constants/mediaQueries';
import ProductModel from 'models/Product';
import VariantModel from 'models/Variant';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const SPACING_LARGE = Theme.get('spacing') * 4;
const SPACING_SMALL = Theme.get('spacing') * 2;

const ProductInfo = ({ product, variant }) => (
  <div className={'ProductInfo'} key={`ProductInfo--${product.id}`}>
    <div className="ProductInfo__image-container">
      <Image
        src={product.defaultImage.src}
        alt={product.defaultImage?.alt}
        className="ProductInfo__image"
        transformations={{ backgroundColor: IMAGE_BG_COLOR }}
        width={IMAGE_WIDTHS.W_400}
        ratio={IMAGE_RATIOS.R_1x1}
      />
    </div>
    <div className="ProductInfo__details-container">
      <div className="ProductInfo-details">
        <p className="ProductInfo__master-product-name">{product.masterName}</p>
        {product.colorName && <p className="ProductInfo__detail">{product.colorName}</p>}
        {!product.isUnisize && !product.isGiftCard && variant?.value && (
          <p className="ProductInfo__detail">
            {I18n.localize('cart.lineItem.size')}: {variant.value}
          </p>
        )}
      </div>
    </div>

    <style jsx>
      {`
        .ProductInfo {
          position: relative;
          display: flex;
          background-color: ${Theme.get('colors-white')};
        }

        .ProductInfo__image-container {
          margin-right: ${SPACING_LARGE}px;
          width: ${IMAGE_WIDTHS.W_100}px;
          background-color: ${IMAGE_BG_COLOR};
          position: relative;
        }

        .ProductInfo__master-product-name {
          margin: 0;
          line-height: 20px;
          color: ${Theme.get('colors-black')};
          font-size: ${Theme.get('font-size-px')};
          letter-spacing: ${Theme.get('letter-spacing-px')};
          font-weight: ${Theme.get('font-weight-semi-bold')};
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .ProductInfo__details-container {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          overflow: hidden;
        }

        .ProductInfo__detail {
          margin: 0;
          line-height: 20px;
          color: ${Theme.get('colors-black')};
          letter-spacing: ${Theme.get('letter-spacing-px')};
          font-size: ${Theme.get('font-size-small-px')};
          font-weight: ${Theme.get('font-weight-normal')};
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        @media ${mediumUp} {
          .ProductInfo-details {
            margin-bottom: ${SPACING_SMALL}px;
          }
        }
      `}
    </style>
  </div>
);

ProductInfo.propTypes = {
  product: PropTypes.instanceOf(ProductModel),
  variant: PropTypes.instanceOf(VariantModel),
};

export default ProductInfo;
